var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.eqDivClass },
    [
      _vm.job.lob === "SI"
        ? _c("cargo-ag-grid", {
            staticStyle: {
              width: "100%",
              height: "200px",
              "margin-bottom": "5px"
            },
            attrs: {
              "config-module": "130003",
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.finalColumnDefs,
              "row-data": _vm.finalRowData,
              "auto-fit-content": false
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        : _c("cargo-ag-grid", {
            staticStyle: {
              width: "100%",
              height: "200px",
              "margin-bottom": "5px"
            },
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.finalColumnDefs,
              "show-side-bar": false,
              "row-data": _vm.finalRowData,
              "auto-fit-content": false
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          }),
      _c("div", { staticStyle: { width: "100%" } }, [
        _c(
          "div",
          { staticStyle: { "text-align": "right", "margin-bottom": "5px" } },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.isEdit &&
                      (_vm.containerLoadType !== "BB" ||
                        _vm.isXy ||
                        _vm.hideSoc),
                    expression:
                      "isEdit&&((containerLoadType!=='BB' || isXy) ||hideSoc)"
                  }
                ],
                attrs: { no: "Add", type: "primary" },
                on: { click: _vm.add }
              },
              [_vm._v(_vm._s(_vm.$t("SeaExport.Add")))]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      (_vm.isEdit &&
                        (_vm.containerLoadType !== "BB" ||
                          _vm.isXy ||
                          _vm.hideSoc)) ||
                      (_vm.isEdit &&
                        _vm.containerLoadType === "BB" &&
                        _vm.rowData &&
                        (_vm.rowData.length > 1 || _vm.isXy)),
                    expression:
                      "(isEdit&&((containerLoadType!=='BB' || isXy) ||hideSoc)) || (isEdit && containerLoadType === 'BB' && rowData && (rowData.length > 1 || isXy))"
                  }
                ],
                attrs: { no: "Delete", type: "danger" },
                on: { click: _vm.remove }
              },
              [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }